import { error, finish } from '../../../modules/banners/actions/get-all-banners';
import api from '../../../api';

export function request(dispatch, { body }) {
    api.get('/banners')
        .then(res => {
            dispatch(finish(res));
        }).catch(err => {
            dispatch(error(err));
        });
}
